export default __webpack_public_path__ + "static/media/Astro_Gemini_Black.fd7160e0.png";